import type { FC } from 'react';



import cn from 'classnames';



import type { TTextViewProps } from '@web/shared/components/text-view';



import styles from './text-view.module.css';


export const TextView: FC<TTextViewProps> = ({
  withoutBorder = false,
  label,
  value,
  rightSlot
}) => {
  const result = (() => {
    if (!value) return 'Не определено'

    return value
  })()

  return (
    <div
      className={cn(styles['text-view'], {
        [styles.withoutBorder]: withoutBorder
      })}
    >
      {label && (
        <span className={styles['label']} title={label}>
          {label}
        </span>
      )}
      <div className={styles['field']}>
        <span
          className={cn(styles.value, { [styles.withRightSlot]: rightSlot })}
        >
          <span className={styles['text']}>{result}</span>
        </span>
        {rightSlot && rightSlot}
      </div>
    </div>
  )
}
